<template>
    <article class="cms-content">
        <slot></slot>
    </article>
</template>

<script>
    export default {
        name: 'CmsContent',
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .cms-content {
        @extend %font-OpenSans-regular;
        font-size:   1.2rem;
        line-height: normal;

        @import '~@/assets/styles/components/_cms-content';
    }
</style>
